import React from "react";
import './index.scss';
import { Carousel } from "antd";
const Testimonials = () => {
 

  return (
    <div className="testimonial-main-container">
      <div className="about-overlay"></div>
      <div className="banner-title-content">
    <Carousel autoplay effect="fade">
            {/* Item 1 */}
            <div className="inner-text-container">
                <div className="testimonial-text">
                  CDC’s overall service in recruiting, screening and assessment of candidates,
                  personalized customer service and relationships are exactly what we look for.
                </div>
             </div>

            {/* Item 2 */}
            <div className="inner-text-container">
                <div className="testimonial-text">
                  CDC has been an important partner for hiring talented people and consistently
                  delivers best-in-class services.
                </div>
             </div>

            {/* Item 3 */}
            <div className="inner-text-container">
                <div className="testimonial-text">
                  CDC has been our partner for years, meeting both temporary and permanent staffing
                  needs with quick turnaround time.
                </div>
              </div>

            {/* Item 4 */}
         <div className="inner-text-container">
                <div className="testimonial-text">
                  CDC works as a true partner, ensuring the right talent with the right skills and
                  cultural fit.
                </div>
           </div>
            </Carousel>
      </div>
            </div>
          
  );
};

export default Testimonials;
